var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loading"}),_c('div',{staticClass:"spin"},[_c('span',{staticClass:"text-center"},[_c('div',{staticStyle:{"height":"150px"},attrs:{"id":"sireh-spiner-full"}}),_c('strong',[_vm._v(_vm._s(_vm.msj))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }